module.exports = __webpack_public_path__ + "media/images/flags/al-f693d7f2896bf0488313d690136e7f38.svg";